import { BEM_BASE, LANDSCAPE_WITH_AD, HIERARCHY, HIERARCHY_SHORT } from './constants';

const getBlockClasses = (type, config = {}) => {
  const cardsSeparatorClass = config.cardsSeparator ? ` ${BEM_BASE}--with-cards-separator` : '';
  const combinedClass = config.combined ? ` ${BEM_BASE}--combined` : '';
  const channelClass = config.channel ? ` bi-channel--${config.channel}` : '';
  const withAdsClass = config.withAds ? ` ${BEM_BASE}--with-ads` : '';
  const withTitleClass = config.withTitle ? ` ${BEM_BASE}--with-title` : '';

  let displayRowClass = '';
  if (type === LANDSCAPE_WITH_AD || type === HIERARCHY || type === HIERARCHY_SHORT) {
    displayRowClass = ' display-row';
  }

  return `row row--wide ${BEM_BASE} ${BEM_BASE}--${type}${combinedClass}${withAdsClass}${withTitleClass}${cardsSeparatorClass}${channelClass}${displayRowClass}`;
};

export default getBlockClasses;
